

export var mixin_lang = ({
    
    computed: {
        lang_level_options() {
          var langLevel = [
              { value: 1, text: 'Langue maternelle' },
              { value: 2, text: 'Courant' },
              { value: 3, text: 'Satisfaisant' },
              { value: 4, text: 'Moyen' },
              { value: 5, text: 'Notions de base' },
          ];
          return langLevel;
        },

        
    },
    
});

